import { Injectable } from '@angular/core';
import { WebApiService } from '../../../shared/services/web-api.service';
import { Page } from "src/app/shared/models/page";
import { Observable, from } from "rxjs";
import { PagedData, PagedDataUserMenu } from "src/app/shared/models/paged-data";
import { HttpErrorResponse, HttpParams } from "@angular/common/http";
import { menuPageParams, PageParams } from "src/app/shared/common/Enums";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor(
    private webApiService: WebApiService,
    private HttpClient:HttpClient
    ) { }

  getSearchResultForImpaOrProduct(partNumber: any,searchPattern:string): Promise<any> {
    let apiUrl = `/search/impa/${partNumber}/${searchPattern}`;
    return this.webApiService.getRequest<any>(apiUrl);
  }

  getSearchResultForService(serviceId: any,searchPattern:string): Promise<any> {
    let apiUrl = `/search/service/${serviceId}/${searchPattern}`;
    return this.webApiService.getRequest<any>(apiUrl);
  }

  getImpaCatalogue(categoryId: any): Promise<any> {
    let apiUrl = `/impa/fetchDetails`;
    return this.webApiService.postRequest<any>(apiUrl, {
      categoryIds: categoryId
    });
  }

  getRelevantSupplierList(searchPattern:string,productId: any): Promise<any> {
    let apiUrl = `/search/supplierList/${searchPattern}/${productId}`;
    return this.webApiService.getRequest<any>(apiUrl);
  }


  fetchFilteredProductList(searchTerm: string,pageMetaData: Page ):Observable<PagedData<any>>{
        
        
      let apiUrl = `/products/productList`;
        let _pageMetadata = new Page();
        if (pageMetaData) {
          _pageMetadata = pageMetaData;
        } else {
          _pageMetadata.pageNumber = 0;
          _pageMetadata.size = 10;
        }
    
        let params = new HttpParams()
          .set(PageParams.limit, _pageMetadata.size)
          .set(PageParams.page, _pageMetadata.pageNumber + 1)
          .set(PageParams.searchParam, searchTerm)
        return this.webApiService.getPaginatedRequest<PagedData<any>>(apiUrl,params)
        .pipe(
          map((paginatedMaster) => {
            // Set page metadata for frontend table properties
            paginatedMaster.page.totalElements = paginatedMaster.count;
            paginatedMaster.page.size = _pageMetadata.size;
            paginatedMaster.page.totalPages = Math.ceil(
              paginatedMaster.count / _pageMetadata.size
            );
            paginatedMaster.page.pageNumber = _pageMetadata.pageNumber;
            paginatedMaster.page.serachParam = _pageMetadata.serachParam;
            console.log('total pages for search==>',paginatedMaster.page.totalPages)
            console.log(paginatedMaster.count,_pageMetadata.size)
            return paginatedMaster;
          }))
      }

      fetchFilterItems(keyword:string,offset:number,searchParam:string,productSearchTerm:string):Promise<any>{
        let apiUrl = `/products/filterItems/${keyword}`;
        let params = new HttpParams()
        .set('page', offset +1)
        .set('searchParam', searchParam)
        .set('productSearchTerm', productSearchTerm)
        return this.webApiService.getRequest<any>(apiUrl,params)
      }

      getDependentFilterItems(
          keyword:string,
          offset:number,
          searchParam:string,
          productSearchTerm:string, 
          category: number[], 
          supplier: number[], 
          supplierType: number[], 
          country: string[], 
          port: number[], 
          pcfRange:string[],
          isImpa: boolean
        ):Promise<any>{
        let apiUrl = `/products/filterItems/${keyword}`;
       
        return this.webApiService.postRequest<any>(apiUrl, {
          offset, 
          searchParam, 
          productSearchTerm, 
          category, 
          supplier, 
          supplierType, 
          country, 
          port, 
          pcfRange,
          isImpa, 
        })
      }

      getDependentFilterItemsCount(
        keyword:string,
        offset:number,
        searchParam:string,
        productSearchTerm:string, 
        category: number[], 
        supplier: number[], 
        supplierType: number[], 
        country: string[], 
        port: number[], 
        pcfRange:string[],
        isImpa: boolean
      ):Promise<any>{
        let apiUrl = `/products/filterItemsCount/${keyword}`;
       
        return this.webApiService.postRequest<any>(apiUrl, {
          offset, 
          searchParam, 
          productSearchTerm,
          category, 
          supplier, 
          supplierType, 
          country, 
          port, 
          pcfRange,
          isImpa,  
         
        })
      }

      fetchFilterItemsCount(keyword:string,offset:number,searchParam:string,productSearchTerm:string):Promise<any>{
        let apiUrl = `/products/filterItemsCount/${keyword}`;
        let params = new HttpParams()
        .set('page', offset +1)
        .set('searchParam', searchParam)
        .set('productSearchTerm', productSearchTerm)
        return this.webApiService.getRequest<any>(apiUrl,params)
      }




      // fetchProducts(searchTerm:string,category: number[], supplier:number[],supplierType:number[],limitNo: number, offsetNo: number): Promise<any> {
      //   const apiUrl = '/search/filterproductsdata';
      //   return this.webApiService.postRequest<any>(apiUrl, {searchTerm, category, supplier,supplierType,limitNo, offsetNo });
      // }

      // fetchProducts(
      //   searchTerm: string,
      //   category: number[], 
      //   supplier: number[], 
      //   supplierType: number[], 
      //   country: string[], 
      //   port: number[], 
      //   pcfRange:string[],
      //   isImpa: boolean, 
      //   limitNo: number, 
      //   offsetNo: number
      // ): Promise<any> {
      //   const apiUrl = '/search/filterproductsdata';
        
      //   // Log the request payload for debugging
      //   console.log('API Request Payload:', {
      //     searchTerm, 
      //     category, 
      //     supplier, 
      //     supplierType, 
      //     limitNo, 
      //     offsetNo
      //   });
      
      //   return this.webApiService.postRequest<any>(apiUrl, {
      //     searchTerm, 
      //     category, 
      //     supplier, 
      //     supplierType, 
      //     country, 
      //     port, 
      //     pcfRange,
      //     isImpa, 
      //     limitNo, 
      //     offsetNo
      //   })
      //     .then((response: any) => {
      //       // Log the raw response for debugging
      //       console.log('API Response:', response);
      //       return response; // Pass the response to the calling function
      //     })
      //     .catch((error: any) => {
      //       // Log the error for debugging
      //       console.error('Error in fetchProducts API call:', error);
      //       throw error; // Re-throw the error to be handled by the calling function
      //     });
      // }
      
       fetchProducts(
        searchTerm: string,
        category: number[],
        brand: number[],
        supplier: number[],
        supplierType: number[],
        country: string[],
        port: number[],
        pcfRange: string[],
        isImpa: boolean,
        limitNo: number,
        offsetNo: number,
        buyerId: number | null = null  // NEW: Optional buyerId parameter
      ): Promise<any> {
        const apiUrl = '/search/filterproductsdata';

        // Log the request payload for debugging
        console.log('API Request Payload:', {
          searchTerm,
          category,
          brand,
          supplier,
          supplierType,
          limitNo,
          offsetNo,
          buyerId
        });

        return this.webApiService.postRequest<any>(apiUrl, {
          searchTerm,
          category,
          brand,
          supplier,
          supplierType,
          country,
          port,
          pcfRange,
          isImpa,
          limitNo,
          offsetNo,
          buyerId  // NEW: Include buyerId in the request
        })
          .then((response: any) => {
            // Log the raw response for debugging
            console.log('API Response:', response);
            return response; // Pass the response to the calling function
          })
          .catch((error: any) => {
            // Log the error for debugging
            console.error('Error in fetchProducts API call:', error);
            throw error; // Re-throw the error to be handled by the calling function
          });
      }

      // Get services list for search page
      getServicesList(searchTerm: string, page: number, limit: number, buyerId: number | null = null): Promise<any> {
        let apiUrl = `/services/getServicesList`;
        let params = new HttpParams()
          .set('searchTerm', searchTerm || '')
          .set('page', page.toString())
          .set('limit', limit.toString());
        if (buyerId) {
          params = params.set('buyerId', buyerId.toString());
        }
        return this.webApiService.getRequest<any>(apiUrl, params);
      }

      // Service Cart Methods
      addServiceToCart(serviceId: number, quantity: number): Promise<any> {
        let apiUrl = `/services/cart/add`;
        return this.webApiService.postRequest<any>(apiUrl, {
          serviceId: serviceId,
          quantity: quantity
        });
      }

      getServiceCartItems(): Promise<any> {
        let apiUrl = `/services/cart/fetch`;
        return this.webApiService.getRequest<any>(apiUrl);
      }

      updateServiceCart(cartId: number, quantity: number): Promise<any> {
        let apiUrl = `/services/cart/update/${cartId}`;
        return this.webApiService.putRequest<any>(apiUrl, {
          quantity: quantity
        });
      }

      deleteServiceCartItem(cartId: number): Promise<any> {
        let apiUrl = `/services/cart/${cartId}`;
        return this.webApiService.deleteRequest<any>(apiUrl);
      }

      // Service RFQ Methods
      getLastServiceRfqId(): Promise<any> {
        let apiUrl = `/services/rfq/getLastServiceRfqId`;
        return this.webApiService.getRequest<any>(apiUrl);
      }

      createServiceRfq(params: any): Promise<any> {
        let apiUrl = `/services/rfq/createServiceRfq`;
        return this.webApiService.postRequest<any>(apiUrl, params);
      }

      getServiceRfqDraftData(serviceRfqId: number): Promise<any> {
        let apiUrl = `/services/rfq/getDraftData/${serviceRfqId}`;
        return this.webApiService.getRequest<any>(apiUrl);
      }

      saveServiceRfqHeader(params: any): Promise<any> {
        let apiUrl = `/services/rfq/saveHeader`;
        return this.webApiService.postRequest<any>(apiUrl, params);
      }

      // Service RFQ Line Items
      getServiceRfqLineItems(serviceRfqId: number): Promise<any> {
        let apiUrl = `/services/rfq/getLineItems/${serviceRfqId}`;
        return this.webApiService.getRequest<any>(apiUrl);
      }

      saveServiceRfqLineItems(params: any): Promise<any> {
        let apiUrl = `/services/rfq/saveLineItems`;
        return this.webApiService.postRequest<any>(apiUrl, params);
      }

}